import { useMutation, useQueryClient } from "@tanstack/react-query"
import axios from "axios"
import { setAuthToken } from "modules/auth/lib/setAuthToken"
import { DataResponse, LoginResponseDataSchema, SwitchOrganizationSchema } from "schema"
import { z } from "zod"

type SwitchOrganizationInput = z.infer<typeof SwitchOrganizationSchema>
type SwitchOrganizationResponse = DataResponse<z.infer<typeof LoginResponseDataSchema>>

export const useSwitchOrganizationMutation = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async (data: SwitchOrganizationInput) => {
      const response = await axios.post<SwitchOrganizationResponse>(
        "/auth/switch-organization",
        data,
      )
      return response.data.data
    },
    onSuccess: (data) => {
      setAuthToken({ queryClient, token: data.token })
      window.location.href = "/"
    },
  })
}
